// extracted by mini-css-extract-plugin
module.exports = {"masterIcon":"content-elements_masterIcon__QexSq"};